var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-card-block card sm-radius"},[_c('upload-file',{attrs:{"title":_vm.title,"type":_vm.type},on:{"show-progress":_vm.showProgress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }